import React, { Component } from 'react';
import './index.css'
import { BsyUtils } from '../../utils/Utils';
import BsySlidePane from "../BsySlidePane";
import BsyWebhookSsoPane from "./BsyWebhookSsoPane";
import BsySwitchBtn from "../BsySwitchBtn";
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import imgkfptweihuoqu from "../../images/img_kfpt_weihuoqu@2x.png";
import wushujutuisong from "../../images/img_weipeizhi@2x.png";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import { NavLink } from "react-router-dom";
import DocumentTitle from 'react-document-title';
import { setPageTitle } from '../../utils/setPageTitle';


class BsyWebhookSso extends Component {
    constructor(props) {
        super(props);
        this.serverVal = React.createRef();

    }

    componentDidMount() {
        this.loadWebHook()
    }

    loadWebHook = () => {
        this.setState({ success: false })
        React.axios("/webhook/sso_config", {}).then((res) => {
            let sso = res.data.data.sso_config
            this.setState({
                success: true,
                enable: sso.enable,
                ssoType: sso.ssoType,
                type: sso.type,
                sso_endpoint: sso.sso_endpoint,
                sig_crt: sso.sig_crt,
                sig_alg: sso.sig_alg,
                issuer: sso.issuer,
                slo_endpoint: sso.slo_endpoint,
                custom_secret: sso.custom_secret,
                custom_sso_endpoint: sso.custom_sso_endpoint,
                custom_sig_alg: sso.custom_sig_alg,
                custom_issuer: sso.custom_issuer,
                custom_slo_endpoint: sso.custom_slo_endpoint,
                hasSso: res.data.sso
            })
        })
    }

    onSave = (e, ref) => {
        this.setState({ enable: true, ...e }, () => {
            React.axios('/sso/update_Config', {
                sso_config: {
                    config: {
                        enable: true, ...e
                    },
                    type: e.type
                },
            }).then(() => {
                ref.closeAlter()
            })
        })
    }

    state = {
        success: false,
        enable: false,
        type: "saml",
        sso_endpoint: "",
        sig_crt: "",
        sig_alg: "",
        issuer: "",
        slo_endpoint: "",
        custom_secret: "",
        custom_sso_endpoint: "",
        custom_sig_alg: "",
        custom_issuer: "",
        custom_slo_endpoint: ""
    }

    openWebHookSso = (val) => {
        return () => {
            BsySlidePane({
                title: React.language('sso.config.title'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <BsyWebhookSsoPane config={this.state} onSave={this.onSave} pane={ref} />
                },
            })
        }
    }

    configured = () => {
        const { sso_endpoint, sig_crt, sig_alg, issuer, slo_endpoint, custom_secret, custom_sso_endpoint, custom_sig_alg, custom_issuer, custom_slo_endpoint } = this.state;
        return sso_endpoint || sig_crt || sig_alg || issuer || slo_endpoint || custom_secret || custom_sso_endpoint || custom_sig_alg || custom_issuer || custom_slo_endpoint
    }

    dashboardMenuCenterMenu = () => {
        return <div className="open-header">
            <NavLink activeClassName="select" className="api-webhook" to={window.rootDirectroy + "/open/api"}>
                <div className="header-btn"><span>api</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="key-webhook" to={window.rootDirectroy + "/open/key"}>
                <div className="header-btn"><span>{React.language('key.management')}</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="form-webhook" to={window.rootDirectroy + "/open/webhook"}>
                <div className="header-btn"><span>webhook</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="modules-webhook" to={window.rootDirectroy + "/open/modules"}>
                <div className="header-btn"><span>{React.language('module')}</span></div>
            </NavLink>
            {window.FX.STATIC["user_corps"]["mode"] === "common" && <NavLink activeClassName="select" className="sso-webhook" to={window.rootDirectroy + "/open/sso"}>
                <div className="header-btn"><span>{React.language('account.signin.sso')}</span></div>
            </NavLink>}
        </div>
    }

    leftTitle = () => {
        return <div className="leftTitle">
            <span>{React.language('open.platform')}</span>
        </div>
    }

    clearSsoConfig = () => {
        BsyAlert({
            title: React.language("sso.clearConfig.title"),
            msg: React.language("sso.clearConfig.msg"),
            type: "query",
            text4Ok: React.language("clear"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                React.axios('/sso/update_Config', {
                    sso_config: {},
                }).then(() => {
                    this.setState({
                        enable: false,
                        type: 'saml',
                        sso_endpoint: '',
                        sig_crt: '',
                        sig_alg: '',
                        issuer: '',
                        slo_endpoint: '',
                        custom_secret: '',
                        custom_sso_endpoint: '',
                        custom_sig_alg: '',
                        custom_issuer: '',
                        custom_slo_endpoint: ''
                    })
                })
            }
        })
    }

    switchChange = (e) => {
        const { type, sso_endpoint, sig_crt, sig_alg, issuer, slo_endpoint, custom_secret, custom_sso_endpoint, custom_sig_alg, custom_issuer, custom_slo_endpoint } = this.state;
        React.axios('/sso/update_Config', {
            sso_config: {
                config: {
                    enable: e,
                    type: type,
                    sso_endpoint: sso_endpoint,
                    sig_crt: sig_crt,
                    sig_alg: sig_alg,
                    issuer: issuer,
                    slo_endpoint: slo_endpoint,
                    custom_secret: custom_secret,
                    custom_sso_endpoint: custom_sso_endpoint,
                    custom_sig_alg: custom_sig_alg,
                    custom_issuer: custom_issuer,
                    custom_slo_endpoint: custom_slo_endpoint
                },
                type: type
            },
        }).then(() => {
            this.setState({ enable: e })
        })
    }

    handleCopy = (v) => {
        return () => {
            BsyUtils.copyToClipboard(v)
            tipAlert({
                type: "success",
                msg: React.language('app.edit.copy.success')
            });
        }
    };

    render() {
        const { success, hasSso, enable, type, sso_endpoint, sig_crt, secret, sig_alg, issuer, slo_endpoint, custom_secret, custom_sso_endpoint, custom_sig_alg, custom_issuer, custom_slo_endpoint } = this.state;
        let isCustom = type === 'custom';
        let corpId = window.FX.STATIC.corpId;
        let url = isCustom ? "sso/custom/" : "sso/saml2/";
        url = (window.root_directroy ? window.root_directroy + '/' : '') + url;
        setPageTitle("开放平台 - 单点登录");
        return (

            <div className="BsyWebhookSso">
                <BsyDashboardMenu dashboardMenuCenterMenu={this.dashboardMenuCenterMenu}
                    leftTitle={this.leftTitle} />
                {success && <div className="open-pane">
                    {this.configured() ? <div className="openList">
                        <div className="sso-switch">
                            <div className="sso-title">{React.language('vip.center.sso')}</div>
                            <BsySwitchBtn switchChange={this.switchChange} power={enable} />
                            <div className="sso-tip"></div>
                        </div>
                        {
                            enable && <div className="sso-config-content">
                                <div className="sso-config-title">
                                    {React.language('sso.config.content.title')}
                                </div>
                                <div className="sso-config-list">
                                    <div className="share-item">
                                        <div className="share-title">
                                            {isCustom ? React.language('sso.custom') : React.language('sso.saml')}
                                        </div>
                                        <div className="share-cont">
                                            {isCustom ? custom_sso_endpoint : sso_endpoint}
                                        </div>
                                    </div>
                                    <div className="share-item">
                                        <div className="share-title">
                                            {React.language('sso.cert')}
                                        </div>
                                        <div className="share-cont">
                                            {window.FX.CONFIG.HOST.SITE_HOST + url + corpId + "/acs"}
                                        </div>
                                        <div className="share-copy" onClick={this.handleCopy(window.FX.CONFIG.HOST.SITE_HOST + url + corpId + "/acs")}>
                                            {React.language('copy')}
                                        </div>
                                    </div>
                                    {!isCustom && <div className="share-item">
                                        <div className="share-title">
                                            {React.language('sso.meta')}
                                        </div>
                                        <div className="share-cont">
                                            {window.FX.CONFIG.HOST.SITE_HOST + url + corpId + "/metadata"}
                                        </div>
                                        <div className="share-copy" onClick={this.handleCopy(window.FX.CONFIG.HOST.SITE_HOST + url + corpId + "/metadata")}>
                                            {React.language('copy')}
                                        </div>
                                    </div>}
                                    <div className="share-item">
                                        <div className="share-title">
                                            {React.language('sso.signout')}
                                        </div>
                                        <div className="share-cont">
                                            {window.FX.CONFIG.HOST.SITE_HOST + url + corpId + "/slo"}
                                        </div>
                                        <div className="share-copy" onClick={this.handleCopy(window.FX.CONFIG.HOST.SITE_HOST + url + corpId + "/slo")}>
                                            {React.language('copy')}
                                        </div>
                                    </div>
                                </div>
                                <div className="sso-config-footer">
                                    <div className="sso-config-btn">
                                        <div className="sso-modify-config" onClick={this.openWebHookSso()}>
                                            <span>{React.language('modifyConfig')}</span>
                                        </div>
                                        <div className="sso-clear-config" onClick={this.clearSsoConfig}>
                                            <span>{React.language('clearConfig')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div> : <div className="openListEmpty">
                        <div className="emptyCont">
                            <div className="emptyImg">
                                <img style={{ width: hasSso ? "108px" : "260px" }} src={hasSso ? wushujutuisong : imgkfptweihuoqu} alt="" />
                            </div>
                            <div className="emptyTip">
                                <span>{hasSso ? React.language("sso.empty.config.tip") : window.FX.STATIC["user_corps"]["mode"] === "common" ? React.language("purview.sso.tip") : React.language("sso.other.team.tip")}</span>
                            </div>
                            <div className="emptyBtn">
                                {hasSso && <div className="emptyCreateBtn" onClick={this.openWebHookSso()}>
                                    <span>{React.language("config")}</span>
                                </div>}
                            </div>
                        </div>
                    </div>}
                </div>}
            </div>

        );
    }
}

export default BsyWebhookSso;